import React from 'react';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var PreviewLink = function PreviewLink() {
  var _window$location$path;

  if (!true) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  var url = (_window$location$path = window.location.pathname) !== null && _window$location$path !== void 0 ? _window$location$path : '/';
  var href = "/api/v1/preview?secret=".concat(process.env.REACT_APP_PREVIEW_SECRET, "&url=").concat(url);
  return /*#__PURE__*/_jsx("div", {
    style: {
      textAlign: 'center',
      width: '100%',
      padding: 20
    },
    children: /*#__PURE__*/_jsx("a", {
      style: {
        color: 'white'
      },
      href: href,
      children: "Shareable preview link"
    })
  });
};